import { signal, Show, type Child } from "zyra";
import { CodeBlock } from "./CodeBlock";

/** A live component example paired with its copyable source. */
export function UIPreview(props: {
  id: string;
  title: string;
  description: string;
  code: string;
  children?: Child;
}) {
  const expanded = signal(false);
  return (
    <section
      id={props.id}
      class="ui-preview"
      aria-labelledby={props.id + "-title"}
    >
      <div class="ui-preview-heading">
        <div>
          <h3 id={props.id + "-title"}>{props.title}</h3>
          <p>{props.description}</p>
        </div>
        <button
          class="ui-source-toggle"
          aria-expanded={expanded.value}
          aria-controls={props.id + "-code"}
          onClick={() => {
            expanded.value = !expanded.value;
          }}
        >
          {expanded.value ? "Hide code" : "View code"}
          <span aria-hidden="true"> &lt;/&gt;</span>
          <span class="sr-only"> for {props.title}</span>
        </button>
      </div>
      <div class="ui-preview-canvas">{props.children}</div>
      <div id={props.id + "-code"}>
        <Show when={expanded.value}>
          <CodeBlock text={props.code} language="tsx" />
        </Show>
      </div>
    </section>
  );
}
